// account routes
const accountRoutes = [
  {
    path: '/sign-up',
    name: 'sign-up',
    component: () => import('../views/assemble-account/SignUp.vue'),
    meta: {
      requiresAuth: false,
      layout: 'login',
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/assemble-account/Login.vue'),
    meta: {
      requiresAuth: false,
      layout: 'login',
    }
  },
  {
    path: '/reset',
    name: 'reset',
    component: () => import('../views/assemble-account/Reset.vue'),
    meta: {
      requiresAuth: false,
      layout: 'login',
    }
  },
  {
    path: '/reset/:token',
    name: 'reset.submit',
    component: () => import('../views/assemble-account/ResetSubmit.vue'),
    meta: {
      requiresAuth: false,
    }
  },
  {
    path: '/verify',
    name: 'verify',
    meta: {
      layout: 'login',
      requiresAuth: false,
    },
    component: () => import('../views/assemble-account/Verify.vue'),
  },
  {
    path: '/pending',
    name: 'pending',
    meta: {
      layout: 'login',
      requiresAuth: false,
    },
    component: () => import('../components/NoAccess.vue'),
  }
];

// Entities Management
const entityRoutes = [
  {
    path: '/nationals',
    name: 'nationals.list',
    meta: {
      displayName: 'Nationals',
      layout: 'app',
    },
    component: () => import('../views/entities/nationals/NationalList.vue')
  },
  {
    path: '/nationals/add',
    name: 'nationals.add',
    props: true,
    meta: {
      displayName: 'Add National',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/entities/nationals/NationalForm.vue'),
  },
  {
    path: '/nationals/:id',
    name: 'nationals.update',
    props: true,
    meta: {
      displayName: 'Edit National',
      layout: 'app',
      view: 'table',
      requiresAuth: true,
    },
    component: () => import('../views/entities/nationals/NationalForm.vue'),
  },
  // teams
  {
    path: '/states',
    name: 'states.list',
    props: true,
    meta: {
      displayName: 'States',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/entities/states/StateList.vue'),
  },
  {
    path: '/states/add',
    name: 'states.add',
    props: true,
    meta: {
      displayName: 'States',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/entities/states/StateForm.vue'),
  },
  {
    path: '/states/:id',
    name: 'states.update',
    props: true,
    meta: {
      displayName: 'States',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/entities/states/StateForm.vue'),
  },
  // associations
  {
    path: '/associations',
    name: 'associations.list',
    props: true,
    meta: {
      displayName: 'Associations',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/entities/associations/AssociationList.vue'),
  },
  {
    path: '/associations/add',
    name: 'associations.add',
    props: true,
    meta: {
      displayName: 'Associations',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/entities/associations/AssociationForm.vue'),
  },
  {
    path: '/associations/:id',
    name: 'associations.update',
    props: true,
    meta: {
      displayName: 'Associations',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/entities/associations/AssociationForm.vue'),
  },
  // clubs
  {
    path: '/clubs',
    name: 'clubs.list',
    props: true,
    meta: {
      displayName: 'Clubs',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/entities/clubs/ClubList.vue'),
  },
  {
    path: '/clubs/add',
    name: 'clubs.add',
    props: true,
    meta: {
      displayName: 'Clubs',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/entities/clubs/ClubForm.vue'),
  },
  {
    path: '/clubs/:id',
    name: 'clubs.update',
    props: true,
    meta: {
      displayName: 'Clubs',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/entities/clubs/ClubForm.vue'),
  },
  {
    path: '/club-members/:id/',
    name: 'club-members.update',
    props: true,
    meta: {
      displayName: 'Members',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/entities/clubs/MemberDetails.vue'),
  },
  // teams
  {
    path: '/teams',
    name: 'teams.list',
    props: true,
    meta: {
      displayName: 'Teams',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/entities/teams/TeamList.vue'),
  },
  {
    path: '/teams/add',
    name: 'teams.add',
    props: true,
    meta: {
      displayName: 'Teams',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/entities/teams/TeamDetails.vue'),
  },
  {
    path: '/teams/:id',
    name: 'teams.update',
    props: true,
    meta: {
      displayName: 'Teams',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/entities/teams/TeamDetails.vue'),
  },
  // squads
  {
    path: '/squads',
    name: 'squads.list',
    props: true,
    meta: {
      displayName: 'Squads',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/managements/squads/Squads.vue'),
  },
  {
    path: '/squads/:id',
    name: 'squads.update',
    props: true,
    meta: {
      displayName: 'Squads',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/managements/squads/SquadDetails.vue'),
  },
  // Rego-clearances
  {
    path: '/rego-clearances/:id',
    name: 'rego-clearance.update',
    props: true,
    meta: {
      displayName: 'Rego-Clearances',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/managements/registration-clearances/registration-clearances-details.vue'),
  },
  {
    path: '/rego-clearances',
    name: 'rego-clearances.list',
    props: true,
    meta: {
      displayName: 'Rego-Clearances',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/managements/registration-clearances/registration-clearances.vue'),
  },
  // venues
  {
    path: '/venues',
    name: 'venues.list',
    props: true,
    meta: {
      displayName: 'Venues',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/entities/venues/VenueList.vue'),
  },
  {
    path: '/venues/add',
    name: 'venues.add',
    props: true,
    meta: {
      displayName: 'Venues',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/entities/venues/VenueForm.vue'),
  },
  {
    path: '/venues/:id',
    name: 'venues.update',
    props: true,
    meta: {
      displayName: 'Venues',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/entities/venues/VenueForm.vue'),
  }
];

const administrationRoutes = [
  {
    path: '/documentations',
    name: 'documentations',
    meta: {
      displayName: 'Assemble Documentation',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/support/Support.vue'),
  },
  {
    path: '/release-notes',
    name: 'release-notes',
    meta: {
      displayName: 'Release Notes',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/release-notes/index.vue'),
  },
  {
    path: '/payment-settings',
    name: 'payment-settings',
    meta: {
      displayName: 'Payment Settings',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/payment-settings/PaymentSettings'),
  },
  {
    path: '/payment-settings/add',
    name: 'payment-settings.add',
    props: true,
    meta: {
      displayName: 'Payment Settings',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/payment-settings/components/PaymentSettingDetails'),
  },
  {
    path: '/payment-settings/:id',
    name: 'payment-settings.update',
    props: true,
    meta: {
      displayName: 'Payment Settings',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/payment-settings/components/PaymentSettingDetails'),
  },
  {
    path: '/card-details',
    name: 'card-details',
    meta: {
      displayName: 'Payment Card',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/administrations/payment-card/PaymentCard.vue'),
    // component: () => import('../views/administrations/AccountDetails.vue'),
  },
  {
    path: '/manual-registration',
    name: 'manual-registration',
    meta: {
      displayName: 'Manual Registration',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    props: true,
    component: () => import('../views/administrations/manual-registration/ManualRego.vue')
  },
  {
    path: '/team-manual-registration',
    name: 'team-manual-registration',
    meta: {
      displayName: 'Team Manual Registration',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    props: true,
    component: () => import('../views/administrations/manual-registration/TeamManualRego.vue')
  },
  {
    path: '/indv-manual-registration',
    name: 'indv-manual-registration',
    meta: {
      displayName: 'Individual Manual Registration',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    props: true,
    component: () => import('../views/administrations/manual-registration/IndvManualRego.vue')
  },
  {
    path: '/family-manual-membership-registration',
    name: 'family-manual-membership-registration',
    meta: {
      displayName: 'Family Manual Membership Registration',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    props: true,
    component: () => import('../views/administrations/manual-registration/FamilyManualRego.vue')
  },
  {
    path: '/team-payment',
    name: 'team-payment',
    meta: {
      displayName: 'Team Payments',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/administrations/team-payment/Payment.vue'),
  },
  {
    path: '/management',
    name: 'managements',
    meta: {
      displayName: 'Management',
      layout: 'app',
      requiresAuth: true,
      view: 'tab'
    },
    props: true,
    component: () => import('../views/managements/Managements.vue'),
  },
  {
    path: '/additional-questions/create',
    name: 'additional-questions.create',
    meta: {
      displayName: 'Create Additional Questions',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/managements/additional-questions/ModifyAdditionalQuestions.vue'),
  },
  {
    path: '/additional-questions/:id',
    name: 'additional-questions.update',
    meta: {
      displayName: 'Update Additional Questions',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/managements/additional-questions/ModifyAdditionalQuestions.vue'),
  },
  {
    path: '/membership-required/create',
    name: 'membership-required.create',
    meta: {
      displayName: 'Membership Required',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/managements/membership-required/ModifyMembershipRequired.vue'),
  },
  {
    path: '/membership-required/:id',
    name: 'membership-required.update',
    meta: {
      displayName: 'Membership Required',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/managements/membership-required/ModifyMembershipRequired.vue'),
  },
  // {
  //   path: '/communications',
  //   name: 'communications',
  //   meta: {
  //     displayName: 'Communications',
  //     layout: 'app',
  //     view: 'report',
  //     requiresAuth: true,
  //   },
  //   component: () => import('../views/administrations/Communications.vue'),
  // },
  // {
  //   path: '/file-explorer',
  //   name: 'file-explorer',
  //   meta: {
  //     displayName: 'File Explorer',
  //     layout: 'app',
  //     requiresAuth: true,
  //   },
  //   component: () => import('../views/managements/file-management/FileExplorer.vue')
  // },
  // {
  //   path: '/team-payment',
  //   name: 'team-payment',
  //   meta: {
  //     displayName: 'Team Payments',
  //     layout: 'app',
  //     requiresAuth: true,
  //   },
  //   component: () => import('../views/administrations/team-payment/Outstanding.vue'),
  // },
  // {
  //   path: '/team-pay-per-person',
  //   name: 'team-pay-per-person',
  //   meta: {
  //     displayName: 'Team Pay Per Person',
  //     layout: 'app',
  //     requiresAuth: true,
  //   },
  //   component: () => import('../views/administrations/team-payment/TeamPayPerPerson.vue'),
  // },
  {
    path: '/users/:userId',
    name: 'users.update',
    meta: {
      displayName: 'User Management',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/managements/user-management/UserManagement.vue'),
  },
  // {
  //   path: '/team-registrations',
  //   name: 'team-registrations',
  //   meta: {
  //     displayName: 'Team Registrations',
  //     layout: 'app',
  //     requiresAuth: true,
  //   },
  //   component: () => import('../views/managements/team-registrations/TeamRegistrations.vue')
  // },
  // {
  //   path: '/members',
  //   name: 'members',
  //   meta: {
  //     displayName: 'Members',
  //     layout: 'app',
  //     requiresAuth: true,
  //   },
  //   component: () => import('../views/managements/members/Members.vue'),
  // },
  {
    path: '/members/:id',
    name: 'members.update',
    props: true,
    meta: {
      displayName: 'Member Details',
      layout: 'app',
      requiresAuth: true,
      view: 'tab'
    },
    component: () => import('../views/managements/members/MemberDetail.vue'),
  },
  {
    path: '/accreditations',
    name: 'accreditations',
    meta: {
      displayName: 'Accreditations',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/accreditations/AccreditationList.vue'),
  },
  {
    path: '/accreditation-create',
    name: 'accreditations.create',
    meta: {
      displayName: 'Accreditation Create',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/accreditations/AccreditationInsert.vue'),
  },
  {
    path: '/accreditation-update/:id',
    name: 'accreditations.update',
    meta: {
      displayName: 'Accreditation Update',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/accreditations/AccreditationDetails.vue'),
  },
  {
    path: '/result-groups',
    name: 'result-groups',
    meta: {
      displayName: 'Quick Results',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/results/ResultGroups.vue'),
  },
  {
    path: '/reports',
    name: 'reports.list',
    meta: {
      displayName: 'Reports',
      layout: 'app',
      view: 'report',
      requiresAuth: true,
    },
    component: () => import('../views/reports/Reports.vue'),
  },
  {
    path: '/notifications',
    name: 'notifications.list',
    meta: {
      displayName: 'Report History',
      layout: 'app',
      view: 'report',
      requiresAuth: true,
    },
    component: () => import('../views/notifications/index.vue'),
  },
  {
    path: '/reports/financial',
    name: 'reports.financial',
    meta: {
      displayName: 'Reports',
      layout: 'app',
      view: 'report',
      requiresAuth: true,
    },
    component: () => import('../views/reports/FinancialReports.vue')
  },
  {
    path: '/download-report',
    name: 'download-report',
    meta: {
      displayName: 'Download Report',
      layout: 'login',
      requiresAuth: false,
    },
    component: () => import('../views/reports/DownloadReport.vue')
  },
  {
    path: '/communications',
    name: 'communications',
    meta: {
      displayName: 'Communications',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/communications/Communications.vue'),
  },
];

const registrationMgmtRoutes = [
  {
    path: '/discount-codes',
    name: 'discount-codes',
    meta: {
      displayName: 'Discount Codes',
      layout: 'app',
      requiresAuth: false,
    },
    component: () => import('../views/discount-codes/DiscountCodes.vue')
  },
];

const competitionRoutes = [
  {
    path: '/competition-types',
    name: 'competition-types.list',
    meta: {
      displayName: 'Competition Types',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/competition-types/CompetitionTypes.vue'),
  },
  {
    path: '/competition-types/create',
    name: 'competition-types.create',
    meta: {
      displayName: 'Competition Type Create',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/competition-types/CompetitionTypeCreate.vue'),
  },
  {
    path: '/competition-types/:id',
    name: 'competition-types.update',
    meta: {
      displayName: 'Competition Type Update',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/competition-types/CompetitionTypeUpdate.vue'),
  },
  // competitions
  {
    path: '/competition-management',
    name: 'competitions.management',
    meta: {
      displayName: 'Competition Manager',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/competitions/CompManagement.vue'),
  },
  {
    path: '/competitions',
    name: 'competitions.list',
    meta: {
      displayName: 'Competitions',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/competitions/Competitions.vue'),
  },
  {
    path: '/competitions/create',
    name: 'competitions.create',
    meta: {
      displayName: 'Competition Create',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/competitions/CompetitionCreate.vue'),
  },
  {
    path: '/competitions/:id',
    name: 'competitions.update',
    meta: {
      displayName: 'Competition Update',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/competitions/CompetitionUpdate.vue'),
  },
  {
    path: '/competitions/:id/redo-draw',
    name: 'competitions.redo-draw',
    meta: {
      displayName: 'Redo Draw',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/redo-draws/RedoDraw.vue'),
  },
  {
    path: '/redo-draw-multiple',
    name: 'competitions.redo-draw-multiple',
    meta: {
      displayName: 'Redo Draw Multiple',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/redo-draws/RedoDrawMultiple.vue'),
  },
  {
    path: '/forms',
    name: 'forms.list',
    meta: {
      displayName: 'Forms',
      layout: 'app',
      requiresAuth: true
    },
    component: () => import('../views/forms/FormsList.vue'),
  },
  {
    path: '/forms/new',
    name: 'forms.add',
    meta: {
      displayName: 'Forms',
      layout: 'app',

      view: 'report',
      requiresAuth: true
    },
    component: () => import('../views/forms/Forms.vue'),
  },
  {
    path: '/forms/:id',
    name: 'forms.update',
    meta: {
      displayName: 'Forms',
      layout: 'app',

      view: 'report',
      requiresAuth: true
    },
    component: () => import('../views/forms/Forms.vue'),
  },
  {
    path: '/forms/submitted-form/:id',
    name: 'submittedform.view',
    meta: {
      displayName: 'Submitted Form',
      layout: 'app',

      view: 'report',
      requiresAuth: true
    },
    component: () => import('../views/forms/SubmittedForm.vue'),
  },
  {
    path: '/events',
    name: 'events.list',
    meta: {
      displayName: 'Events',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/events/EventList.vue'),
  },
  {
    path: '/featured-list',
    name: 'feature.list',
    meta: {
      displayName: 'Feature List',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/featured-list/FeaturedList.vue'),
  },
  {
    path: '/events/create',
    name: 'events.create',
    meta: {
      displayName: 'Create Event',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/events/EventCreate.vue'),
  },
  {
    path: '/events/:id',
    name: 'events.update',
    props: true,
    meta: {
      displayName: 'Event Update',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/events/EventUpdate.vue'),
  },
  // memberships
  {
    path: '/memberships',
    name: 'memberships.list',
    meta: {
      displayName: 'Memberships',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/memberships/MembershipList.vue'),
  },
  {
    path: '/memberships/create',
    name: 'memberships.create',
    meta: {
      displayName: 'Membership Create',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/memberships/MembershipCreate.vue'),
  },
  {
    path: '/memberships/:id',
    name: 'memberships.update',
    meta: {
      displayName: 'Membership Update',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/memberships/MembershipUpdate.vue'),
  },
  // entity-registrations
  {
    path: '/entity-memberships',
    name: 'entity-memberships.list',
    meta: {
      displayName: 'Entity Memberships',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/entity-memberships/EntityMembershipList.vue'),
  },
  {
    path: '/entity-memberships/create',
    name: 'entity-memberships.create',
    meta: {
      displayName: 'Entity Membership Create',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/entity-memberships/EntityMembershipCreate.vue'),
  },
  {
    path: '/entity-memberships/:id',
    name: 'entity-memberships.update',
    meta: {
      displayName: 'Entity Membership Update',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/entity-memberships/EntityMembershipUpdate.vue'),
  },
  // matches
  {
    path: '/fixture-explorer',
    name: 'fixture-explorer',
    meta: {
      displayName: 'Fixture Explorer',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/competitions/FixtureExplorer.vue')
  },
  {
    path: '/matches',
    name: 'matches.list',
    meta: {
      displayName: 'Matches',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/matches/Matches.vue'),
  },
  {
    path: '/matches/create',
    name: 'matches.create',
    meta: {
      displayName: 'Match Create',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/matches/MatchCreate.vue'),
  },
  {
    path: '/matches/:id',
    name: 'matches.update',
    meta: {
      displayName: 'Matches Update',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/matches/MatchUpdate.vue'),
  },
  {
    path: '/draw-management',
    name: 'draw.management',
    meta: {
      displayName: 'Draw Management',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/draws/DrawManagement.vue'),
  },
  {
    path: '/draws',
    name: 'draws.list',
    meta: {
      displayName: 'Draws',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/draws/Draws.vue'),
  },
  {
    path: '/draws/builder',
    name: 'draws.builder',
    meta: {
      displayName: 'Draws',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/draws/DrawBuilder.vue'),
  },
  {
    path: '/draws/import',
    name: 'draws.import',
    meta: {
      displayName: 'Draw Import',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/draws/DrawImport.vue'),
  },
  {
    path: '/draws/auto-builder',
    name: 'draws.auto-builder',
    meta: {
      displayName: 'Auto Draw Builder',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/draws/DrawAutoBuilder.vue'),
  },
  {
    path: '/draws/:id',
    name: 'draws.update',
    meta: {
      displayName: 'Draw Update',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/draws/DrawUpdate.vue'),
  },
  // tag groups
  {
    path: '/tag-groups',
    name: 'tagGroups.list',
    props: true,
    meta: {
      displayName: 'Labels',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/tag-groups/Labels.vue'),
  },
  {
    path: '/tag-groups/add',
    name: 'tagGroups.add',
    props: true,
    meta: {
      displayName: 'Labels',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/tag-groups/TagGroupForm.vue'),
  },
  {
    path: '/tag-groups/:id',
    name: 'tagGroups.update',
    props: true,
    meta: {
      displayName: 'Labels',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/tag-groups/TagGroupForm.vue'),
  },
  {
    path: '/sub-product-groups',
    name: 'subProductGroups.list',
    props: true,
    meta: {
      displayName: 'Labels',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/tag-groups/Labels.vue'),
  },
  {
    path: '/sub-product-groups/add',
    name: 'subProductGroups.add',
    props: true,
    meta: {
      displayName: 'Labels',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/tag-groups/SubProductGroupForm.vue'),
  },
  {
    path: '/sub-product-groups/:id',
    name: 'subProductGroups.update',
    props: true,
    meta: {
      displayName: 'Labels',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/tag-groups/SubProductGroupForm.vue'),
  },
  // saleableItems
  {
    path: '/saleable-items',
    name: 'saleableItems.list',
    props: true,
    meta: {
      displayName: 'Saleable Items',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/saleable-items/SaleableItemsManagement.vue'),
  },
  {
    path: '/saleable-items/add',
    name: 'saleableItems.add',
    props: true,
    meta: {
      displayName: 'Saleable Items',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/saleable-items/SaleableItemsForm.vue'),
  },
  {
    path: '/saleable-items/:id',
    name: 'saleableItems.update',
    props: true,
    meta: {
      displayName: 'Saleable Items',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/saleable-items/SaleableItemsForm.vue'),
  },
];

const indvCompetitionRoutes = [
  {
    path: '/indv-competition-types',
    name: 'indv-competition-types.list',
    meta: {
      displayName: 'Individual Competition Types',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/indv-competition-types/CompetitionTypes.vue'),
  },
  {
    path: '/indv-competition-types/create',
    name: 'indv-competition-types.create',
    meta: {
      displayName: 'Individual Competition Type Create',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/indv-competition-types/CompetitionTypeCreate.vue'),
  },
  {
    path: '/indv-competition-types/:id',
    name: 'indv-competition-types.update',
    meta: {
      displayName: 'Individual Competition Type Update',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/indv-competition-types/CompetitionTypeUpdate.vue'),
  },
  // competitions
  {
    path: '/indv-competitions',
    name: 'indv-competitions.list',
    meta: {
      displayName: 'Individual Competitions',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/indv-competitions/Competitions.vue'),
  },
  {
    path: '/indv-competitions/create',
    name: 'indv-competitions.create',
    meta: {
      displayName: 'Individual Competition Create',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/indv-competitions/CompetitionCreate.vue'),
  },
  {
    path: '/indv-competitions/:id',
    name: 'indv-competitions.update',
    meta: {
      displayName: 'Individual Competition Update',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/indv-competitions/CompetitionUpdate.vue'),
  },
  // matches
  {
    path: '/indv-matches',
    name: 'indv-matches.list',
    meta: {
      displayName: 'Individual Matches',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/indv-matches/Matches.vue'),
  },
  {
    path: '/indv-matches/create',
    name: 'indv-matches.create',
    meta: {
      displayName: 'Individual Match Create',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/indv-matches/MatchCreate.vue'),
  },
  {
    path: '/indv-matches/:id',
    name: 'indv-matches.update',
    meta: {
      displayName: 'Individual Match Update',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/indv-matches/MatchUpdate.vue'),
  },
  {
    path: '/indv-draws',
    name: 'indv-draws.list',
    meta: {
      displayName: 'Individual Draws',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/indv-draws/Draws.vue'),
  },
  {
    path: '/indv-draws/builder',
    name: 'indv-draws.builder',
    meta: {
      displayName: 'Individual Draw Builder',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/indv-draws/DrawBuilder.vue'),
  },
  {
    path: '/indv-draws/auto-builder',
    name: 'indv-draws.auto-builder',
    meta: {
      displayName: 'Auto Draw Builder',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/indv-draws/DrawAutoBuilder.vue'),
  },
  {
    path: '/indv-draws/import',
    name: 'indv-draws.import',
    meta: {
      displayName: 'Individual Draw Import',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/indv-draws/DrawImport.vue'),
  },
  {
    path: '/indv-draws/:id',
    name: 'indv-draws.update',
    meta: {
      displayName: 'Individual Draw Update',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/indv-draws/DrawUpdate.vue'),
  },
  {
    path: '/indv-draw-management',
    name: 'indv-draw.management',
    meta: {
      displayName: 'Indv Draw Management',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('@/views/indv-draws/DrawManagement.vue'),
  },
  {
    path: '/indv-ladders',
    name: 'indv-ladders.list',
    meta: {
      displayName: 'Individual Ladders',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/indv-ladders/LaddersList.vue'),
  },
  {
    path: '/indv-ladders/:id',
    name: 'indv-ladders.update',
    meta: {
      displayName: 'Individual Ladders Update',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/indv-ladders/LaddersForm.vue'),
  },
  {
    path: '/indv-scheduler',
    name: 'indv-scheduler',
    meta: {
      displayName: 'Individual Smart Scheduler',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/indv-scheduler/Scheduler.vue'),
  },
];

const ladderRoutes = [
  {
    path: '/ladders',
    name: 'ladders.list',
    meta: {
      displayName: 'Ladders',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/ladders/LaddersList.vue'),
  },
  {
    path: '/ladders/:id',
    name: 'ladders.update',
    meta: {
      displayName: 'Ladders Update',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/ladders/LaddersForm.vue'),
  },
  {
    path: '/scheduler',
    name: 'scheduler',
    meta: {
      displayName: 'Smart Scheduler',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/scheduler/Scheduler.vue'),
  },
];

const mailTemplatesRoutes = [
  {
    path: '/mail-templates',
    name: 'mail-templates.list',
    meta: {
      displayName: 'Mail Templates',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/mail-templates/MailTemplates.vue'),
  },
  {
    path: '/mail-templates/create',
    name: 'mail-templates.create',
    meta: {
      displayName: 'Mail Template',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/mail-templates/MailTemplateDetails.vue'),
  },
  {
    path: '/mail-templates/:id',
    name: 'mail-templates.update',
    meta: {
      displayName: 'Mail Template',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/mail-templates/MailTemplateDetails.vue'),
  }
];

const landingPagesRoutes = [
  {
    path: '/landing-pages',
    name: 'landing-pages.list',
    meta: {
      displayName: 'Landing Pages',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/landing-pages/LandingPages.vue'),
  },
  {
    path: '/landing-pages/create',
    name: 'landing-pages.create',
    meta: {
      displayName: 'Landing Pages',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/landing-pages/LandingPageDetails.vue'),
  },
  {
    path: '/landing-pages/:id',
    name: 'landing-pages.update',
    meta: {
      displayName: 'Landing Pages',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/landing-pages/LandingPageDetails.vue'),
  }
];

const regrading = [
  {
    path: '/team-regrading',
    name: 'regrading.list',
    meta: {
      displayName: 'Team Regrading',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('@/views/team-regrading/RegradingList.vue')
  },
  {
    path: '/team-regrading/regrade',
    name: 'regrading.regrade',
    meta: {
      displayName: 'Re-Grade Team',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('@/views/team-regrading/RegradingSteps.vue')
  },
  {
    path: '/team-regrading/:id',
    name: 'regrading.details',
    meta: {
      displayName: 'Team Regrading Details',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('@/views/team-regrading/RegradingDetails.vue')
  },
];

const bookingRoutes = [
  {
    path: '/bookings',
    name: 'bookings.list',
    meta: {
      displayName: 'Booking Slots',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/bookings/Slots.vue'),
  },
  {
    path: '/bookings/create',
    name: 'bookings.create',
    meta: {
      displayName: 'New Booking Slot',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/bookings/NewSlots.vue'),
  },
  {
    path: '/bookings/:id',
    name: 'bookings.details',
    meta: {
      displayName: 'Booking Slot Details',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/bookings/SlotDetails.vue'),
  },
];
const widgetRoutes = [
  {
    path: '/widgets',
    name: 'widgets.list',
    meta: {
      displayName: 'Widget List',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/widgets/widgetList.vue'),
  },
  {
    path: '/widgets/create',
    name: 'widgets.create',
    meta: {
      displayName: 'New Widget',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/widgets/widgetDetails.vue'),
  },
  {
    path: '/widget/:id',
    name: 'widgets.details',
    meta: {
      displayName: 'Widget Details',
      layout: 'app',
      view: 'report',
      requiresAuth: true,
    },
    component: () => import('../views/widgets/widgetDetails.vue'),
  },
];
const documentRoutes = [
  {
    path: '/folders',
    name: 'folders.list',
    meta: {
      displayName: 'Document Library',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/documents/DocumentFolders.vue'),
  },
  {
    path: '/folder/:id',
    name: 'documents.details',
    meta: {
      displayName: 'Document Library',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/documents/Documents.vue'),
  },
];
const appointmentRoutes = [
  {
    path: '/appointments',
    name: 'appointments',
    meta: {
      displayName: 'Appointments',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/appointments/AppointmentBoards.vue'),
  },
  {
    path: '/appointments/create',
    name: 'appointments.create',
    meta: {
      displayName: 'New Appointment',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/appointments/NewAppointmentBoard.vue'),
  },
  {
    path: '/appointments/:id',
    name: 'appointments.details',
    meta: {
      displayName: 'Appointment Details',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/appointments/AppointmentBoardDetails.vue'),
  },
  {
    path: '/my-board',
    name: 'my-appointment-board',
    meta: {
      displayName: 'My Appointment Board',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/appointment-admin/board-management.vue'),
  },
  {
    path: '/my-board-availability',
    name: 'my-board-availability',
    meta: {
      displayName: 'My Board Availability',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/appointment-admin/refereeList.vue'),
  },
  {
    path: '/my-board-availability/referee/:id',
    name: 'my-board-referee-availability-update',
    meta: {
      displayName: 'My Board Availability Referee Update',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/appointment-admin/referee-availability.vue'),
  },
  {
    path: '/my-board/match/:id',
    name: 'board-match-details',
    meta: {
      displayName: 'Board-Match Details',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/appointment-admin/boardManagementDetail.vue'),
  },
];

const incidentRoutes = [
  {
    path: '/incidents',
    name: 'incidents.list',
    meta: {
      displayName: 'Incidents',
      layout: 'app',
      view: 'tab',
      requiresAuth: true,
    },
    component: () => import('../views/incidents/Incidents.vue'),
  },
];

module.exports = [
  {
    path: '/',
    meta: {
      displayName: 'Dashboard',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/dashboard/DashboardNew.vue'),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      displayName: 'Dashboard',
      layout: 'app',
      requiresAuth: true,
    },
    component: () => import('../views/dashboard/DashboardNew.vue'),
  },
  {
    path: '/tests/tab',
    meta: {
      displayName: 'Assemble Sports',
      layout: 'app',
      view: 'tab'
    },
    component: () => import('../views/tests/tab.vue'),
  },
  {
    path: '/tests/table',
    meta: {
      displayName: 'Assemble Sports',
      layout: 'app',
    },
    component: () => import('../views/tests/index.vue'),
  },
  {
    path: '*',
    name: 'Error',
    component: () => import('../components/NonExistentPage.vue'),
  },
  ...accountRoutes,
  ...administrationRoutes,
  ...entityRoutes,
  ...registrationMgmtRoutes,
  ...competitionRoutes,
  ...indvCompetitionRoutes,
  ...ladderRoutes,
  ...mailTemplatesRoutes,
  ...landingPagesRoutes,
  ...regrading,
  ...bookingRoutes,
  ...appointmentRoutes,
  ...widgetRoutes,
  ...documentRoutes,
  ...incidentRoutes,
];
